export enum IdentificationFormType {
  REGISTRATION = 1,
  LOGIN,
}
